export default __webpack_public_path__ + "static/media/money_back.18845d1d.svg";